<template>
    <dv-capsule-chart :config="config" style="width:300px;height:200px" />
  </template>
  
  <script>
  export default {
    name: "Addnewstore",
    data() {
      return {
        config: {},
        //折线数据
  
      }
    },
    methods:{
  
    },
  
    created() {
   

       let data=[];
       data[0]={'name':'12月份','value':'80'};
       data[1]={'name':'1月份','value':'100'};
       data[2]={'name':'2月份','value':'119'};
       data[3]={'name':'3月份','value':'150'};
       data[4]={'name':'4月份','value':'80'};


        this.config = {
          data: data,
          colors: ['#e062ae', '#fb7293', '#e690d1', '#32c5e9', '#96bfff'],
          unit: '个',
          showValue: true
        }
  
    },
    watch: {
  
    }
  }
  </script>
  
  <style scoped>
  
  </style>